import styled from 'styled-components';
import { FlexContainer } from 'components/FlexContainer';
import { RadioWrapper } from './Wrapper.styled';
import { Input } from './Input.styled';

import type { FC } from 'react';
import type { RadioOptionProps } from './types';

export const StyledLabel = styled.label`
  font-size: ${({ theme }) => theme.fontSize.xs};

  ${({ theme }) => theme.breakpoints.down('md')} {
    font-size: ${({ theme }) => theme.fontSize.xxs};
  }
`;
export const StyledSubLabel = styled.span`
  color: ${({ theme }) => theme.colors.grey};
`;

export const RadioOption: FC<RadioOptionProps> = ({ value, onChange, name, option, direction }) => {
  const checked = String(option.value) === String(value);

  return (
    <RadioWrapper maxWidth={direction === 'row' ? '75px' : '100%'}>
      <FlexContainer
        alignItems="center"
        justifyContent={direction === 'row' ? 'center' : 'flex-start'}
      >
        <Input
          type="radio"
          id={option.label}
          name={name}
          value={option.value}
          checked={checked}
          onChange={onChange}
        />
        <StyledLabel htmlFor={option.label}>
          {option.label}{' '}
          {option.subLabel && (
            <>
              <br />
              <StyledSubLabel>{option.subLabel}</StyledSubLabel>
            </>
          )}
        </StyledLabel>
      </FlexContainer>
    </RadioWrapper>
  );
};
